import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="&#244;&#128;&#133;&#189;" d="M0.796175 1.80698C0.657502 1.80698 0.528392 1.77112 0.408846 1.69939C0.289301 1.62288 0.191273 1.52485 0.114764 1.40531C0.0382546 1.28098 0 1.1447 0 0.996463C0 0.853008 0.0382546 0.719116 0.114764 0.594789C0.191273 0.470461 0.289301 0.372434 0.408846 0.300706C0.528392 0.228979 0.657502 0.193115 0.796175 0.193115H11.2038C11.3425 0.193115 11.4716 0.228979 11.5912 0.300706C11.7155 0.372434 11.8135 0.470461 11.8852 0.594789C11.9617 0.719116 12 0.853008 12 0.996463C12 1.1447 11.9617 1.28098 11.8852 1.40531C11.8135 1.52485 11.7155 1.62288 11.5912 1.69939C11.4716 1.77112 11.3425 1.80698 11.2038 1.80698H0.796175Z" />
</svg>

`;

export const Minus = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
